var exports = {
  "kL": "x61f99309--ceb25d--container",
  "TW": "x61f99309--ceb25d--container_with_icon",
  "DD": "x61f99309--ceb25d--title",
  "$K": "x61f99309--ceb25d--title_icon",
  "Uo": "x61f99309--ceb25d--buttons",
  "HI": "x61f99309--ceb25d--buttons_centered",
  "hK": "x61f99309--ceb25d--buttons_with_icon",
};

module.exports = exports;
